import { lazy } from 'react';

export const LazyProgressiveCheckoutSignUpPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--progressive-checkout-sign-up-page" */ './progressive-checkout-sign-up-page'
    ),
);
